import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const BIGFIVE_NAMESPACE = "bigfive" as const;
export const bigFiveLanguageMap: Record<"DE" | "UA", "de" | "uk"> = {
  DE: "de",
  UA: "uk",
};

const resources = {
  de: {
    [BIGFIVE_NAMESPACE]: {
      heroTitle: "Big Five Berufsorientierung",
      heroSubtitle:
        "Beantworte die Aussagen spontan und ehrlich. Der Bericht verbindet deinen Arbeitsstil mit realistischen nächsten Schritten fuer Ausbildung und Beruf in Deutschland.",
      instruction: "Wie stark trifft diese Aussage auf dich zu?",
      progress: "{{answered}} von {{total}} beantwortet",
      intake: {
        progress: "Orientierungsschritt {{step}} von {{total}}",
        stepError: "Bitte waehle die benoetigten Angaben aus, damit wir deinen Bericht passend ausrichten koennen.",
      },
      likert: {
        1: "Trifft überhaupt nicht zu",
        2: "Trifft eher nicht zu",
        3: "Teils-teils",
        4: "Trifft eher zu",
        5: "Trifft voll zu",
      },
      navigation: {
        back: "Zurück",
        next: "Weiter",
        submit: "Absenden",
      },
      loading: "Test wird geladen …",
      loadError: "Dieser Test-Link ist ungültig oder abgelaufen.",
      stepError: "Bitte beantworte alle Aussagen auf dieser Seite.",
      submitError: "Die Antworten konnten nicht übermittelt werden. Bitte versuche es erneut.",
      successTitle: "Vielen Dank!",
      successBody:
        "Dein Ergebnis wurde gespeichert. Du erhältst automatisch einen Berufsorientierungsbericht per E-Mail in Deutsch und Ukrainisch.",
      successSubtext: "Du kannst dieses Fenster jetzt schließen oder die nächsten Schritte später mit deinem Coach besprechen.",
      backToStart: "Zurück zum Start",
    },
  },
  uk: {
    [BIGFIVE_NAMESPACE]: {
      heroTitle: "Big Five для професійної орієнтації",
      heroSubtitle:
        "Відповідайте чесно та інтуїтивно. Звіт поєднує ваш стиль роботи з реалістичними наступними кроками для освіти та професії в Німеччині.",
      instruction: "Наскільки ця теза відповідає вам?",
      progress: "Відповіли на {{answered}} із {{total}}",
      intake: {
        progress: "Крок орієнтації {{step}} з {{total}}",
        stepError: "Будь ласка, виберіть потрібні дані, щоб ми могли краще зорієнтувати звіт під ваш шлях.",
      },
      likert: {
        1: "Зовсім не про мене",
        2: "Швидше ні",
        3: "Наполовину",
        4: "Швидше так",
        5: "Цілком про мене",
      },
      navigation: {
        back: "Назад",
        next: "Далі",
        submit: "Надіслати",
      },
      loading: "Тест завантажується…",
      loadError: "Це посилання недійсне або вже використано.",
      stepError: "Будь ласка, дайте відповіді на всі твердження цієї сторінки.",
      submitError: "Не вдалося надіслати відповіді. Спробуйте ще раз.",
      successTitle: "Дякуємо!",
      successBody:
        "Результати збережено. Повний звіт для професійної орієнтації буде автоматично надіслано на e-mail німецькою та українською мовами.",
      successSubtext: "Можете закрити це вікно або пізніше обговорити наступні кроки з коучем.",
      backToStart: "Повернутися на головну",
    },
  },
};

if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources,
    lng: "de",
    fallbackLng: "de",
    supportedLngs: ["de", "uk"],
    ns: [BIGFIVE_NAMESPACE],
    defaultNS: BIGFIVE_NAMESPACE,
    interpolation: {
      escapeValue: false,
    },
  });
}

export default i18n;
